export interface ReqBodyWithHeaders {
	method: APIMethods
	url: string
	client: string
	sessionId: string
	[name: string]: any
	timelineId?: string
	platformName?: string
}

export interface ReqBodyWithoutHeaders {
	method: APIMethods
	url: string
	client: string
	[name: string]: any
}

export enum APIMethods {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
}
